import { useModal } from '@topconagriculture/modal';
import { inventoryLargeModalName } from './InventoryWidgetConfig';
import { InventoryViewMode } from './inventory.types';
export const useWarningClick = () => {
    const { dispatchOpenModal } = useModal();
    const inventory = [];
    const openModal = (viewMode) => dispatchOpenModal({
        modalName: inventoryLargeModalName,
        modalParams: { inventoryViewMode: viewMode, inventory },
        modalOptions: {
            modalDialogProps: {
                maxWidth: 'lg',
            },
        },
    });
    const onCriticalClick = () => {
        openModal(InventoryViewMode.CRITICAL);
    };
    const onEarlyClick = () => {
        openModal(InventoryViewMode.EARLY);
    };
    return { onCriticalClick, onEarlyClick };
};
//# sourceMappingURL=useWarningClick.js.map